export default {"src":"/_next/static/media/logo-white.39d4c7df.svg","height":46,"width":197,"blurWidth":0,"blurHeight":0};